<template>
     <el-dialog title="修改商户信息" :visible.sync="modifyBsDialog" width="35%" top="5vh" center style="border: 1px solid #01DFD7" :close-on-click-modal = false
               :close-on-press-escape = false v-loading="loading"  element-loading-text="请求处理中" element-loading-spinner="el-icon-loading"  
               element-loading-background="rgba(0.8, 0, 0, 0.3)" @close="closeDialog">
        <el-card>
            <el-form ref="detailDialog" :model="bsForm" label-width="80px">
                <el-form-item label="商户账号">
                    <el-input v-model="bsForm.account" :placeholder="this.response.data.phone" disabled></el-input>
                </el-form-item>
                <el-form-item label="商户类型" align="left">
                <el-radio-group v-model="bsForm.type" @change="selectType()">
                    <el-radio :label="global.bs_type[1].code" >{{ global.bs_type[1].message }}</el-radio>
                    <el-radio :label="global.bs_type[0].code" >{{ global.bs_type[0].message }}</el-radio>
                </el-radio-group>
                </el-form-item>
                <el-form-item label="主体名称">
                    <el-input v-model="bsForm.subjectName" :placeholder="this.response.data.subjectName"></el-input>
                </el-form-item>
                <el-form-item label="联系电话"> <el-input v-model="bsForm.phone" :placeholder="this.response.data.phone" clearable></el-input> </el-form-item>
                <el-form-item label="邮箱"><el-input v-model="bsForm.email" :placeholder="this.response.data.email" clearable></el-input></el-form-item>
                <el-form-item label="地区">
                    <el-select v-model="bsForm.province" clearable :placeholder="this.response.data.provinceStr" @change="provinceChoose" style="width:160px">
                        <el-option v-for="item in this.province" :key="item.code" :label="item.value" :value="item.code" ></el-option>
                    </el-select>
                    <el-select v-model="bsForm.city" clearable :placeholder="this.response.data.cityStr" @change="cityChoose" style="width:160px">
                        <el-option v-for="item in this.city" :key="item.code" :label="item.value" :value="item.code"></el-option>
                    </el-select>
                    <el-select v-model="bsForm.area" clearable :placeholder="this.response.data.areaStr" style="width:160px" @change="areaChoose">
                        <el-option v-for="item in this.area" :key="item.code" :label="item.value" :value="item.code"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="地址"><el-input v-model="bsForm.address" :placeholder="this.response.data.address" clearable></el-input></el-form-item>
                <el-form-item label="开通分润" align="left">
                    <el-radio-group v-model="bsForm.rewardFlag">
                        <el-radio label="1">是</el-radio>
                        <el-radio label="0">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="分润比例" v-if="bsForm.rewardFlag == '1'">
                <el-input v-model="bsForm.rewardPercent" :disabled="false" :placeholder="this.response.data.rewardPercent" clearable></el-input>
                </el-form-item>
                    <el-form-item label="分润比例" v-else>
                    <el-input v-model="bsForm.rewardPercent" :disabled="true" :placeholder="this.response.data.rewardPercent" clearable></el-input>
                </el-form-item>
                <el-form-item label="可见账单">
                    <el-radio-group v-model="bsForm.billFlag">
                        <el-radio label="0">不可见</el-radio>
                        <el-radio label="1">可见</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="账号状态">
                    <el-radio-group v-model="bsForm.delFlag">
                        <el-radio label="0">正常</el-radio>
                        <el-radio label="1">冻结</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
        </el-card>
        <span slot="footer" class="dialog-footer">
            <el-button style="background-color:#A9F5F2;margin: 0" @click="modifyBsDialog = false">取消</el-button>
            <el-button style="background-color:#A9F5A9" @click="modifyCs">确定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import {getBsById, updateBusiness, exportData} from "../../api/usermanagement/bsList.js";
export default {
    data() {
        return {
            modifyBsDialog: false,
            loading: false,
            bsForm: {
                id: "",
                account: "",
                type: "",
                typeStr: "",
                subjectName: "",
                gender: "",
                genderStr: "",
                phone: "",
                email: "",
                province: "",
                provinceStr: "",
                city: "",
                cityStr: "",
                area: "",
                areaStr: "",
                address: "",
                rewardFlag: "",
                rewardPercent: "",
                billFlag: "",
                delFlag: ""
            },
            global: '',
            province: '',
            city: '',
            area: '',
            requestSucceed: false,
            response: {data: []}
        }
    },
    methods: {
        init(id){
            this.bsForm.id = id;
            this.modifyBsDialog = true;
            getBsById(id).then(result=>{
                this.bsForm.type = result.data.type;
                this.bsForm.gender = result.data.gender;
                this.bsForm.rewardFlag = result.data.rewardFlag;
                this.bsForm.billFlag = result.data.billFlag;
                this.bsForm.delFlag = result.data.delFlag;
                this.response.data = result.data;
            })
        },

        /**
         * 代理类型选择
         */
        selectType(value){
            this.bsForm.typeStr = value === "0" ? "个人" : "企业";
        },

        /**
         * 修改代理信息
         */
        modifyCs(){
            this.bsForm.type = this.bsForm.type === '' ? this.response.data.type : this.bsForm.type;
            this.bsForm.typeStr = this.bsForm.typeStr === '' ? this.response.data.typeStr : this.bsForm.typeStr;
            this.bsForm.subjectName = this.bsForm.subjectName === '' ? this.response.data.subjectName : this.bsForm.subjectName;
            this.bsForm.phone = this.bsForm.phone === '' ? this.response.data.phone : this.bsForm.phone;
            this.bsForm.email = this.bsForm.email === '' ? this.response.data.email : this.bsForm.email;
            this.bsForm.province = this.bsForm.province === '' ? this.response.data.province : this.bsForm.province;
            this.bsForm.provinceStr = this.bsForm.provinceStr === '' ? this.response.data.provinceStr : this.bsForm.provinceStr;
            this.bsForm.city = this.bsForm.city === '' ? this.response.data.city : this.bsForm.city;
            this.bsForm.cityStr = this.bsForm.cityStr === '' ? this.response.data.cityStr : this.bsForm.cityStr;
            this.bsForm.area = this.bsForm.area === '' ? this.response.data.area : this.bsForm.area;
            this.bsForm.areaStr = this.bsForm.areaStr === '' ? this.response.data.areaStr : this.bsForm.areaStr;
            this.bsForm.address = this.bsForm.address === '' ? this.response.data.address : this.bsForm.address;
            this.bsForm.rewardPercent = this.bsForm.rewardPercent === '' ? this.response.data.rewardPercent : Number(this.bsForm.rewardPercent);
            updateBusiness(this.bsForm).then(result=>{
                this.$emit('modify-succeed','添加成功')
                this.$message({
                    message: "操作成功",
                    type: "success",
                    duration: 1500,
                });
                this.modifyBsDialog = false;
            })
        },

        /**
         * 关闭弹窗
         */
        closeDialog(){
            this.bsForm.account = "";
            this.bsForm.type = "";
            this.bsForm.typeStr = "";
            this.bsForm.subjectName = "";
            this.bsForm.gender = "0";
            this.bsForm.genderStr = "";
            this.bsForm.phone = "";
            this.bsForm.email = "";
            this.bsForm.province = "";
            this.bsForm.provinceStr = "";
            this.bsForm.city = "";
            this.bsForm.cityStr = "";
            this.bsForm.area = "";
            this.bsForm.areaStr = "";
            this.bsForm.address = "";
            this.bsForm.rewardFlag = "";
            this.bsForm.rewardPercent = "";
            this.requestSucceed = false;
        },

        /**
        * 省下拉框选择触发事件
        */
        provinceChoose(value){
            this.bsForm.city = '';
            this.bsForm.area = '';
            for (let item of this.province) {
            if (value == item.code) {
                this.bsForm.provinceStr = item.value;
                this.city = item.childrenDictList
            }
            }
        },

        /**
        * 市下拉框选择触发事件
        */
        cityChoose(value){
            this.bsForm.area = '';
            for (let item of this.city) {
                if (value == item.code) {
                    this.bsForm.cityStr = item.value;
                    this.area = item.childrenDictList;
                }
            }
        },

        /**
        * 区下拉框选择触发事件
        */
        areaChoose(value){
            for (let item of this.area) {
                if (value == item.code) {
                    this.bsForm.areaStr = item.value;
                }
            }
        },
    },
    created() {
        this.global = JSON.parse(sessionStorage.getItem("global"));
        this.province = JSON.parse(sessionStorage.getItem("dict")).area;
    }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/usermanagement/modifyBs.vue